/**
 *
 *  Reviews Modal
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 10/07/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useState } from "react";
import { bool, func, arrayOf, shape, string, number } from "prop-types";
import Modal from "react-modal";
import moment from "moment-timezone";

import { useAppState } from "../../state";
import { useRegion } from "../../context/RegionProvider";

// Components
import Button from "../Button/Button";
import TrainerRating from "../TrainerRating/TrainerRating";

// Hooks
import useTheme from "../ThemeProvider/useTheme/useTheme";

// Icons
import StarFullIcon from "../../icons/StarFullIcon";
import CloseIcon from "../../icons/CloseIcon";

// Utils
import { clientWidth } from "../../utils";
import { getMomentWithTz } from "../../utils/date";
import { modalStyles, PAGE_SIZE } from "../../constants";

export const Reviews = ({
  // isModalOpen,
  partnerId,
  partnerReviews,
  // partnerProducts,
  onLoadMoreReviews,
  // onClose,
}) => {
  // const { theme } = useTheme();
  const { region } = useRegion();

  const {
    // partnerReviews,
    isFetching,
    hasMoreReviews,
    partnerReviewsPage,
    // partnerReviewsLoaded,
    // clearPartnerReviewsLoaded, // eslint-disable-line no-unused-vars
  } = useAppState();

  // // eslint-disable-next-line no-unused-vars
  // const [isCompact, setIsCompact] = useState(false);
  // // eslint-disable-next-line no-unused-vars
  // const [_isModalOpen, setIsModalOpen] = useState(true);
  //
  // const modalResolveRef = React.useRef();

  const showLoadMoreButton =
    hasMoreReviews && partnerReviews.length >= PAGE_SIZE;

  return (
    <div className="panel-reviews-body tbk-bg-grey-light tbk-px-2 tbk-pt-2 tbk-pb-2 md:tbk-rounded-b-lg lg:tbk-overflow-auto lg:tbk-px-4">
      <div className="tbk-mb-3">
        <div className="tbk-mb-4 tbk-flex">
          <h4 className="tbk-text-title-bold tbk-text-primary">Reviews</h4>
        </div>
        {partnerReviews.map((review, index) => {
          var stars = [];

          for (var i = 0; i < review.rating; i++) {
            stars.push(<StarFullIcon className="tbk-text-coral" key={i} />);
          }

          return (
            <div className="partner-review-item tbk-mb-4" key={index}>
              <div className="after:tbk-content-[' '] tbk-relative tbk-pb-1.5 after:tbk-absolute after:tbk-left-7 after:tbk-bottom-0 after:tbk-h-1.5 after:tbk-w-[28px] after:tbk-bg-review-arrow">
                <div className="tbk-rounded-lg tbk-bg-basic-white tbk-p-2 tbk-shadow-trube">
                  <div className="tbk-mb-1 tbk-flex">{stars}</div>
                  <div className="tbk-text-main tbk-mb-1 tbk-text-primary">
                    {review.review}
                  </div>
                </div>
              </div>
              <div className="tbk-text-secondary tbk-text-grey">
                <p className="tbk-mb-1">
                  {review.customerFirstName}
                  {review.customerLastName
                    ? ` ${review.customerLastName.charAt(0)}.`
                    : ""}{" "}
                  <span className="tbk-text-grey-inactive">after</span>{" "}
                  {review.productName} Session{" "}
                  <span className="tbk-text-grey-inactive">
                    (
                    {getMomentWithTz(moment.utc(review.date), region).format(
                      "DD MMM YYYY"
                    )}
                    )
                  </span>
                </p>
              </div>
              {/*{index !== partnerReviews.length - 1 ? <hr /> : null}*/}
            </div>
          );
        })}
        {showLoadMoreButton && (
          <Button
            className={
              "btn btn-trube tb-spacing-top-medium tb-spacing-md-top-extra-large"
            }
            onClick={() => onLoadMoreReviews(partnerId, partnerReviewsPage + 1)}
            showLoader={isFetching}
            disabled={isFetching}
          >
            Load more
          </Button>
        )}
      </div>
    </div>
  );
};

Reviews.displayName = "Reviews";

Reviews.propTypes = {
  isModalOpen: bool,
  partnerId: string.isRequired,
  partnerProducts: arrayOf(shape({ id: string, name: string })),
  onLoadMoreReviews: func.isRequired,
  // onClose: func.isRequired,
};

export default Reviews;
